export default __webpack_public_path__ + "static/media/group-634.bd27e303.png";